/** Кількість учасників з узгодженим словом: «1 учасник», «4 учасники», «5 учасників». */
export function formatParticipants(count: number): string {
  const tail = count % 100
  const last = count % 10

  const word =
    tail >= 11 && tail <= 14
      ? 'учасників'
      : last === 1
        ? 'учасник'
        : last >= 2 && last <= 4
          ? 'учасники'
          : 'учасників'

  return `${count} ${word}`
}
